import { FC, useContext, useState } from 'react'
import cx from 'classnames'
import { TeamsFxContext } from '../Context'
import './ConfigurableTab.css'
import { ConfigurableTabAuth } from './ConfigurableTabAuth'
import { Label } from '@fluentui/react-components'
import { useTranslation } from 'react-i18next'

export const ConfigurableTab: FC<object> = () => {
  const [domain, setDomain] = useState<string | null>(localStorage.getItem('domain'))
  const [authToken, setAuthToken] = useState<string | null>(localStorage.getItem('auth_token'))
  const { themeString } = useContext(TeamsFxContext)
  const { t } = useTranslation()

  const handleLoginSuccess = (domain: string | null, nextAuthToken: string | null): void => {
    setDomain(domain)
    setAuthToken(nextAuthToken)

    if (domain !== null) {
      localStorage.setItem('domain', domain)
    } else {
      localStorage.removeItem('domain')
    }

    if (nextAuthToken !== null) {
      localStorage.setItem('auth_token', nextAuthToken)
    } else {
      localStorage.removeItem('auth_token')
    }
  }

  return (
    <div
      id='configure-tab'
      className={cx({
        light: themeString === 'default',
        dark: themeString === 'dark',
        contrast: themeString !== 'default' && themeString !== 'dark'
      })}
    >
      <div>
        <p>
          <Label>{t('LOGIN_DESC_LINE_1')}</Label>
          <br />
          <Label>{t('NOT_A_PLAN_CUSTOMER')}</Label>&nbsp;<a href='https://www.planview.com/contact-us/'>{t('CONTACT_US')}</a>
        </p>
      </div>
      <ConfigurableTabAuth defaultDomain={domain} authToken={authToken} onLoginSuccess={handleLoginSuccess} reLogin={false} />
    </div>
  )
}
